import { GET_INITIATIVE } from "../actions/InitiativeTypes";
const initialState = {
  data: [],
  page: 1,
  total: 0,
  totalPages: 0,
  isLoading: true,
};
const initial = false;
function InitiativeReducer(state = initialState, actions) {
  if (actions.type === GET_INITIATIVE) {
    return {
      ...state,
      ...actions.payload,
    };
  }
  if (
    actions.type === "LOADING" &&
    actions.payload.action_model === GET_INITIATIVE
  ) {
    return {
      ...state,
      isLoading: actions.payload.loading,
    };
  }
  return state;
}

export { InitiativeReducer };
